export default {
	GET: {
		articleList: 'pc/temp/article-list', //文章资讯
		articleDetail: '/default/article-detail', //资讯详情
		// headerindex: '/pc/temp/header', // 头部
		common: '/pc/temp/head-and-tail', // 公共头尾
		stencilindex:'/pc/temp/pc-stencil',	//模板首页
		index: '/pc/temp/index', // 首页
		footer: '/pc/temp/footer', //底部
		shopList: '/default/goods-list', // 商品列表
		shopgoods: '/default/goods', // 商品详情
		shopgoodsleft: '/default/goods-recommend', // 商品详情左侧推荐
		shopcat: '/cart/list', //购物车
		delectshop: '/cart/delete', // 删除购物车商品
		cartnum: '/cart/cart-num', //购物车数量
		rechargeList: '/recharge/list', //余额充值
		rechargeIndex: '/recharge/index', //余额明细
		addressList: '/user/address-list', //地址列表
		addressDelete: 'user/address-delete', //删除地址
		district: '/pc/temp/district', // 地址省市区
		addressDefault: 'user/address-set-default', //设为默认地址
		invoiceList: 'user/get-invoice-list', //发票抬头列表
		orderList: 'order/list', //订单列表
		orderRevoke: 'order/revoke', //取消订单
		orderPay: 'order/pay-data', //订单支付
		orderDetail: 'order/detail', //订单详情
		invoiceLists: 'pc/user/invoice-list', //发票列表
		invoiceDetails: 'pc/user/invoice', //发票详情
		confirm: 'order/confirm', //确认收货
		comment_preview: 'order/comment-preview', //确认收货
		expressDetail: 'order/express-detail', //物流
		refundPreview: 'order/refund-preview', //申请售后
		refundDetail: 'order/refund-detail', //退换货预览
		revokeRefund: 'order/revoke-refund', //撤回申请
		commentList: '/default/comment-list', //商品评价预览
		couponList: 'default/coupon-list', //优惠券
		ccouponReceive: 'coupon/receive', //优惠券领取
		shopFollow: 'mch/index/shop-follow', //商户关注
		shopUnFollow:  'mch/index/un-follow', //商户取消关注
		mchList: 'pc/temp/mch-list', //店铺街
		province: 'pc/temp/province', //店铺街-省份地区
		shopIndex: 'mch/default/index', //店铺首页
		catGoodsList: 'mch/default/cat-goods-list', //店铺商品列表
		myShop: 'mch/user/myshop', //店铺信息
		mchMessage: 'mch/default/mch-message', //入驻店铺-模板信息
		apply: 'mch/index/apply', //个人中心-入驻店铺-审核、交付平台使用费
		mchMoney: 'mch/user/mch-money', //入驻店铺-保证金
		payMoney: 'mch/user/pay-money', //入驻店铺-支付保证金
		allCategories: 'pc/temp/all-categories', //入驻店铺-全部分类
		store: 'default/store',//商城配置
		customerService: 'pc/temp/customer-service',//店铺客服链接
		tjDetails: 'tjzc/goods/details', //天津商品
		hbDetails:'hbzy/goods/getProductDetail',	//河北商品
		sdDetails:'sdzc/goods/index',	//山东商品
		integral:'/integralmall/integralmall/pc-index' , //积分商城首页
		integralDetail:'/integralmall/integralmall/goods-info', //积分商城详情页
		integralPrew:'/integralmall/integralmall/submit-preview', //积分商城订单预览
		integarlPay:'/integralmall/integralmall/submit',//积分订单支付
		integarlOrderList: '/integralmall/integralmall/list', //积分订单列表
		integarlRevoke: '/integralmall/integralmall/revoke', //积分取消订单
		integarlConfirm: '/integralmall/integralmall/confirm', //积分确认收货
		integarlOrderSubmit: '/integralmall/integralmall/order-submit', //积分订单支付
		integarlOrderDetails: '/integralmall/integralmall/clerk-order-details', //积分订单详情
		integarlDetail: '/integralmall/integralmall/integral-detail', //积分明细
		personalintegar:'/integralmall/integralmall/my-integral',	//我的积分
		getCustomerList: '/default/get-customer-list',//获取客服列表
		refund_preview:'/alibaba/order/refund-preview',	//1688-退款退货预览订单
		personalcoupon:"/coupon/index",//我的优惠券
		collstore:"/user/mch-follow-list",//收藏的店铺
		collshop:"/user/favorite-list",		//收藏的商品	
		user_notice:"/mch/default/entry-rules",//入驻商协议  用户须知
		shipment: "order/express-list", //获取快递列表接口
		shipinfo:"order/express-info",  //获取快递详情接口
		getinvoivelist :"user/get-invoice-list",//获取发票抬头列表
		invoice_detail:"user/get-invoice",	//获取发票详情
		server: 'default/paid-art-list',//有偿咨询列表
		forwardsale: "order/get-pre-coupon",  //预售尾款结算优惠券列表
		good_qcode:"default/goods-applet-code",	//商品详情页的用手机查看的二维码
	},
	POST: {
		whether: '/passport/user-occupation', //手机号是否存在
		resSale: '/default/res-sale', //获取短信验证token
		sendCode: '/default/send-code', //获取手机验证码
		register: '/passport/register', //注册
		pcLogin: '/passport/pc-login', //验证码登录
		changePassword: 'passport/change-password', //忘记密码
		userIndex: 'pc/user/pc', //个人中心
		// userIndex: 'pc/user/index', //个人中心
		rechargeSubmit: 'recharge/submit', //充值提交
		shopcar: '/cart/add-cart', // 加入购物车
		orderStatus: 'pc/order-status', //订单状态
		addressSave: 'user/address-save', //地址编辑
		uploadImage: 'default/upload-image', //图片上传
		submitPreview: '/order/new-submit-preview', //预览订单
		newSubmit: '/order/new-submit', //提交订单
		modifycart: '/cart/cart-edit', //购物车修改
		pushInvoice: '/user/push-invoice', //添加发票
		userSave: 'user/user-save', //修改用户信息
		comment: 'order/comment', //修改用户信息
		refund: 'order/refund', //申请售后提交
		refundSend: 'order/refund-send', //申请售后提交
		suitAddcart: 'cart/suit-add-cart', //套餐加入购物车
		favoriteAdd: '/user/favorite-add', // 商品收藏
		favoriteRemove: '/user/favorite-remove', // 商品取消收藏
		applySubmit: 'mch/index/apply-submit',//入驻店铺-提交
		wxLogin: '/passport/wx-login',//微信登录
		wxLoginCheck: 'passport/check',//微信登录校验
		appLogin: 'passport/app-login',//微信登录绑定手机号
		integralSubmit:'/integralmall/integralmall/submit',//积分商城提交订单
		zzDetails: 'zzds/goods/get-goods-info-two', //中直商品
		alirefund:'/alibaba/order/refund',	//1688-售后提交接口
		refund_send: "/alibaba/order/refund-send",//1688-退款退货提交
		sticky_Topic:"/mch/index/oper-top",//置顶收藏店铺
		addinvoice:"user/push-invoice",	//新增发票抬头
		delinvoice:"user/invoice-del",	//删除发票
		setinvoice:"user/invoice-default",	//设定发票默认
		receipt:"order/upload-receipt",  //上传回执单
		affirmsale: "order/pre-bind-coupon", //预售尾款结算使用优惠券
	}
}
